/**
 * PWA Service Worker
 */
let serviceWorkerFile = document.querySelector('meta[name="service-worker"]').getAttribute('content')

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
      navigator.serviceWorker.register(serviceWorkerFile)
          .then(reg => {
              // console.log('Registration succeeded. Scope is ' + reg.scope);
          })
          .catch(registrationError => {
              // console.log('SW registration failed: ', registrationError);
          });
  });
}